import { AssetTypeIdentifierService as OvermapAssetTypeIdentifierService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeIdentifierService extends OvermapAssetTypeIdentifierService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
